<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">

          <card-section-header
            title="Types"
            icon="fas fa-cubes">
          </card-section-header>

          <div class="link-page-group">
            <a [routerLink]="['/', routeRole, 'asset-types']">
              <i class="fas fa-cubes"></i>
              Asset Types
            </a>
            <a [routerLink]="['/', routeRole, 'site-types']">
              <i class="fas fa-dice-d6"></i>
              Site Types
            </a>
            <a [routerLink]="['/', routeRole, 'competency-types']">
              <i class="fas fa-ruler-vertical"></i>
              Competency Types
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
